var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3v6.554h40.792V3H7zm71.75 0v6.554H121V3H78.75zM7 16.835v6.554h40.792v-6.554H7zm71.75 0v6.554H121v-6.554H78.75zM7 30.306v6.554h40.792v-6.554H7zm71.75 0v6.554H121v-6.554H78.75zM7 60.597c0 22.573.073 23.52 2.55 30.91 2.658 8.047 6.228 13.872 11.8 19.442 9.761 9.685 22.4 14.454 39.736 15 19.887.62 35.002-4.369 45.71-15.145 5.5-5.534 9.615-12.488 11.982-20.243 2.15-6.99 2.222-8.155 2.222-30.073V40.5l-21.015.073-21.052.11s-.182.066-.182 28.943c0 32.984-5.526 38.91-16.192 38.91s-14.901-5.67-14.694-39.747c.172-28.193-.11-28.289-.11-28.289H7v20.097z",
    fill: "#4051b5"
  }));
};